module.exports = __webpack_public_path__ + "static/media/CetraRudy_History_rev.16e20b28.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/vids/CetraRudy_History_rev.mp4
// module id = 149
// module chunks = 0